const readBooleanEnv = (envValue: string | undefined): boolean => {
  return envValue !== undefined && envValue.toLowerCase() === 'true';
};

export default readBooleanEnv;
